import {
  // ACTION / CRUD / INTERACTION
  heroPlus,
  heroPlusSmall as heroPlusSm,
  heroTrash,
  heroArrowUpTray as heroUpload,
  heroArrowDownTray as heroDownload,
  heroFolderPlus as heroFolderAdd,
  heroClipboardDocumentCheck as heroClipboardCheck,
  heroClipboard,
  heroCheck,
  heroXMark as heroX,
  heroXCircle,
  heroArrowTopRightOnSquare as heroExternalLink,
  heroShare,
  heroPencil,
  heroPencilSquare as heroPencilAlt,
  heroCog,
  heroAdjustmentsHorizontal as heroAdjustments,
  heroChatBubbleBottomCenterText as heroAnnotation,
  heroEye,
  heroEyeSlash as heroEyeOff,
  heroBell,
  heroArrowPath as heroRefresh,
  heroStar,

  // STATUS / FEEDBACK / INDICATORS
  heroExclamationTriangle as heroExclamation,
  heroExclamationCircle,
  heroShieldExclamation,
  heroCheckCircle,
  heroInformationCircle,
  heroFingerPrint,
  heroHashtag,
  heroKey,
  heroClock,
  heroCalendar,

  // DATA / DOCUMENT / CONTENT
  heroDocument,
  heroDocumentText,
  heroDocumentChartBar as heroDocumentReport,
  heroBookOpen,
  heroBuildingLibrary as heroLibrary,
  heroQueueList as heroViewList,
  heroSquares2x2 as heroViewBoards,
  heroServer,
  heroFunnel as heroFilter,
  heroPresentationChartBar,
  heroBriefcase,

  // USER / PEOPLE / ORG
  heroUser,
  heroUserPlus as heroUserAdd,
  heroUsers,
  heroUserGroup,
  heroUserCircle,
  heroAcademicCap,
  heroArrowRightOnRectangle as heroLogin,
  heroArrowLeftOnRectangle as heroLogout,
  heroIdentification,

  // COMMUNICATION / TEXT / TAGGING
  heroChatBubbleOvalLeft as heroChat,
  heroChatBubbleLeft as heroChatAlt,
  heroChatBubbleLeftRight as heroChatAlt2,
  heroAtSymbol,
  heroTag,
  heroHashtag as heroHashAlias,
  heroEllipsisVertical as heroDotsVertical,
  heroEllipsisHorizontal as heroDotsHorizontal,
  heroEllipsisHorizontalCircle as heroDotsCircleHorizontal,
  heroLink,
  heroEnvelope as heroMail,
  heroMagnifyingGlass as heroSearch,
  heroPhoneArrowUpRight as heroPhoneOutgoing,

  // EMOTIVE / EXPRESSIVE / MISC
  heroFaceSmile as heroEmojiHappy,
  heroFaceFrown as heroEmojiSad,
  heroFire,
  heroSparkles,
  heroLightBulb,
  heroSun,
  heroNewspaper,

  // NAVIGATION / DIRECTION / MOVEMENT
  heroChevronRight,
  heroArrowRightCircle as heroArrowCircleRight,
  heroArrowLongDown as heroArrowNarrowDown,
  heroArrowLongUp as heroArrowNarrowUp,
  heroArrowUp,
  heroArrowDown,
  heroArrowsPointingOut,
  heroBackward as heroRewind,
  heroArrowsRightLeft as heroSwitchHorizontal,

  // LAYOUT / STRUCTURE / UTILITY
  heroBars3 as heroMenu,
  heroBars3BottomLeft as heroMenuAlt1,
  heroBars3BottomRight as heroMenuAlt2,
  heroBars3CenterLeft as heroMenuAlt3,
  heroBars4 as heroMenuAlt4,
  heroMinus,
  heroCloud,
  heroChartBar,
  heroChartPie,
  heroArrowLeft,
} from "@ng-icons/heroicons/outline";

import {
  heroPlusSolid,
  heroTrashSolid,
  heroArrowUpTraySolid as heroUploadSolid,
  heroCheckSolid,
  heroCogSolid,
  heroAdjustmentsHorizontalSolid as heroAdjustmentsSolid,
  heroBellSolid,
  heroKeySolid,
  heroSquares2x2Solid as heroViewBoardsSolid,
  heroUserSolid,
  heroCodeBracketSolid as heroCodeSolid,
  heroEllipsisHorizontalSolid as heroDotsHorizontalSolid,
  heroEllipsisHorizontalCircleSolid as heroDotsCircleHorizontalSolid,
  heroEnvelopeSolid as heroMailSolid,
  heroFireSolid,
  heroMoonSolid,
  heroChevronDownSolid,
  heroArrowsPointingOutSolid,
  heroStarSolid,
} from "@ng-icons/heroicons/solid";

// ACTION ICONS: create, edit, delete, manage resources
export const HERO_ACTION_ICONS = {
  heroPlus,
  heroPlusSolid,
  heroPlusSm,
  heroTrash,
  heroTrashSolid,
  heroUpload,
  heroUploadSolid,
  heroDownload,
  heroFolderAdd,
  heroClipboardCheck,
  heroClipboard,
  heroCheck,
  heroCheckSolid,
  heroX,
  heroXCircle,
  heroExternalLink,
  heroShare,
  heroPencil,
  heroPencilAlt,
  heroCog,
  heroCogSolid,
  heroAdjustments,
  heroAdjustmentsSolid,
  heroAnnotation,
  heroEye,
  heroEyeOff,
  heroBell,
  heroBellSolid,
  heroRefresh,
  heroStar,
  heroStarSolid,
};

// STATUS / FEEDBACK ICONS: warnings, info, state indicators
export const HERO_STATUS_ICONS = {
  heroExclamation,
  heroExclamationCircle,
  heroShieldExclamation,
  heroCheck,
  heroCheckSolid,
  heroCheckCircle,
  heroInformationCircle,
  heroFingerPrint,
  heroHashtag,
  heroKey,
  heroKeySolid,
};

// TIME / DATE ICONS: temporal data (used by msg_date, elapsed_time, etc.)
export const HERO_TIME_ICONS = {
  heroClock,
  heroCalendar,
};

// DATA / CONTENT ICONS: documents, charts, boards
export const HERO_DATA_ICONS = {
  heroDocument,
  heroDocumentText,
  heroDocumentReport,
  heroBookOpen,
  heroLibrary,
  heroViewList,
  heroViewBoards,
  heroViewBoardsSolid,
  heroServer,
  heroFilter,
  heroPresentationChartBar,
  heroChartBar,
  heroChartPie,
  heroBriefcase,
};

// USER / PEOPLE ICONS
export const HERO_USER_ICONS = {
  heroUser,
  heroUserSolid,
  heroUserAdd,
  heroUsers,
  heroUserGroup,
  heroUserCircle,
  heroAcademicCap,
  heroLogin,
  heroLogout,
  heroIdentification,
  heroCodeSolid,
};

// COMMUNICATION / TAGGING ICONS
export const HERO_COMMUNICATION_ICONS = {
  heroChat,
  heroChatAlt,
  heroChatAlt2,
  heroAtSymbol,
  heroTag,
  heroHashtag: heroHashAlias,
  heroDotsVertical,
  heroDotsHorizontal,
  heroDotsHorizontalSolid,
  heroDotsCircleHorizontal,
  heroDotsCircleHorizontalSolid,
  heroLink,
  heroMail,
  heroMailSolid,
  heroSearch,
  heroPhoneOutgoing,
};

// EMOTIVE / SENTIMENT ICONS
export const HERO_EMOTION_ICONS = {
  heroEmojiHappy,
  heroEmojiSad,
  heroFire,
  heroFireSolid,
  heroSparkles,
  heroLightBulb,
  heroMoonSolid,
  heroSun,
  heroNewspaper,
};

// NAVIGATION / DIRECTION ICONS
export const HERO_NAV_ICONS = {
  heroChevronRight,
  heroChevronDownSolid,
  heroArrowCircleRight,
  heroArrowNarrowDown,
  heroArrowNarrowUp,
  heroArrowUp,
  heroArrowDown,
  heroArrowLeft,
  heroArrowsPointingOut,
  heroArrowsPointingOutSolid,
  heroRewind,
  heroSwitchHorizontal,
};

// LAYOUT / STRUCTURE / UTILITY ICONS
export const HERO_UTILITY_ICONS = {
  heroMenu,
  heroMenuAlt1,
  heroMenuAlt2,
  heroMenuAlt3,
  heroMenuAlt4,
  heroMinus,
  heroCloud,
  heroFolderAdd,
};

export const ALL_HERO_ICON_GROUPS = {
  ...HERO_ACTION_ICONS,
  ...HERO_STATUS_ICONS,
  ...HERO_TIME_ICONS,
  ...HERO_DATA_ICONS,
  ...HERO_USER_ICONS,
  ...HERO_COMMUNICATION_ICONS,
  ...HERO_EMOTION_ICONS,
  ...HERO_NAV_ICONS,
  ...HERO_UTILITY_ICONS,
};
